var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardingClockBg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00016 14.6668C11.6821 14.6668 14.6668 11.6821 14.6668 8.00016C14.6668 4.31826 11.6821 1.3335 8.00016 1.3335C4.31826 1.3335 1.3335 4.31826 1.3335 8.00016C1.3335 11.6821 4.31826 14.6668 8.00016 14.6668ZM8.69461 4.66683C8.69461 4.2833 8.38369 3.97239 8.00016 3.97239C7.61663 3.97239 7.30572 4.2833 7.30572 4.66683V8.00016C7.30572 8.18434 7.37888 8.36098 7.50912 8.49121L9.86614 10.8482C10.1373 11.1194 10.577 11.1194 10.8482 10.8482C11.1194 10.577 11.1194 10.1373 10.8482 9.86614L8.69461 7.71251V4.66683Z",
    fill: "#70758F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingClockBg);
export default __webpack_public_path__ + "static/media/onboarding-clock-bg.4f668300c321e23ac28bde71931757e7.svg";
export { ForwardRef as ReactComponent };